export const SILK = {
    imageHeight: 29,
    imageHeightSmall: 20,
    position: '-10px',
    positionSmall: '0',
    streamBetWidth: '45px',
};

export const LADS_SILK = {
    position: '0px',
};
